export const ROUTES = {
  user: {
    terms: '/terms',
    privacy: '/privacy',
    passwordReset: '/password-reset'
  },
  auth: {
    login: '/login',
    signup: '/signup',
    sso: '/sso',
    unauthorized: '/unauthorized',
    acceptInvitation: '/accept-invitation'
  },
  docs: {
    api: '/docs/api',
    apiModule: '/docs/api/:module',
    apiEntity: '/docs/api/:module/:entity'
  },
  pms: {
    defineComponentLibrary: '/pms/define-component-library',
    components: '/pms/define-component-library/components',
    componentEdit: '/pms/define-component-library/components/:id/edit',
    componentNew: '/pms/define-component-library/components/new',
    spares: '/pms/define-component-library/spares',
    spareNew: '/pms/define-component-library/spares/new',
    spareEdit: '/pms/define-component-library/spares/:id/edit',
    jobs: '/pms/define-component-library/jobs',
    jobNew: '/pms/define-component-library/jobs/new',
    jobEdit: '/pms/define-component-library/jobs/:id/edit',
    vesselComponentLibrary: '/pms/vessels',
    vessels: '/pms/vessels/:vesselId',
    vesselAssign: '/pms/vessels/:vesselId/assign',
    vesselComponentEdit: '/pms/vessels/:vesselId/components/:componentId/edit',
    vesselComponentNew: '/pms/vessels/:vesselId/components/new',
    vesselSpareNew: '/pms/vessels/:vesselId/spares/new',
    vesselSpareEdit: '/pms/vessels/:vesselId/spares/:spareId/edit',
    vesselJobs: '/pms/vessels/:vesselId/jobs',
    vesselJobNew: '/pms/vessels/:vesselId/jobs/new',
    vesselJobEdit: '/pms/vessels/:vesselId/jobs/:jobId/edit',
    mainLibraries: '/pms/main-libraries',
    fleetJobs: '/pms/fleet-jobs',
    fleetJobDetail: '/pms/fleet-jobs/:instanceId',
    approvals: '/pms/approvals'
  },
  pur: {
    overview: '/pur/overview',
    requisitions: '/pur/overview/requisitions',
    requisitionNew: '/pur/requisition/new',
    requisitionPreview: '/pur/requisition/:id',
    rfq: '/pur/overview/rfq',
    purchaseOrders: '/pur/overview/purchase-orders',
    catalogue: '/pur/catalogue',
    vendors: '/pur/vendors'
  },
  chartering: {
    estimator: '/chartering/estimator',
    estimatorNew: '/chartering/estimator-new',
    hybridCalc: '/chartering/hybrid-calc',
    marketIndices: '/chartering/market-indices'
  },
  acc: {
    payments: '/acc/payments',
    paymentOrders: '/acc/payments/orders',
    paymentsV2: '/acc/payments-v2'
  },
  voy: {
    tcin: '/voy/tcin'
  },
  admin: {
    tenantSettings: '/admin/tenant-settings',
    menuEditor: '/admin/menu-editor'
  }
} as const;

export type RouteValue = typeof ROUTES;
